/**
 * Sign-in pages served at the site root (not under `/v2`) by `AuthShellController`.
 * Kept dependency-free: the entry bootstrapper imports it to pick which bundle to load.
 */
export const AuthRoutes = {
  login: "/login",
  register: "/register",
  forgotPassword: "/forgot-password",
  forgotPasswordConfirmation: "/forgot-password-confirmation",
  resetPassword: "/reset-password",
  resetPasswordConfirmation: "/reset-password-confirmation",
  loginTwoFactor: "/login-2fa",
  lockout: "/lockout",
  signupConfirmation: "/signup-confirmation",
  resendConfirmation: "/resend-confirmation",
  externalLoginConfirm: "/external-login/confirm",
  logout: "/logout",
  pinCode: "/pin-code",
  setPinCode: "/set-pin-code",
} as const;

const authPaths = new Set<string>(Object.values(AuthRoutes));

export const isAuthPath = (pathname: string): boolean => {
  const normalized = pathname.replace(/\/+$/, "").toLowerCase() || "/";
  return authPaths.has(normalized);
};
